import React from 'react'
import APP_CONFIG from 'constants/app'
function Footer() {
  return (
    <footer>
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-9 col-12">
                <ul className="footer-text">
                    <li>
                        <p className="mb-0">Copyright © 2025 {APP_CONFIG.ORGANISATION_BRAND}. All rights reserved.</p>
                    </li>
                    <li><a href="#"> V1.0.0 </a></li>
                </ul>
            </div>
            <div className="col-md-3">
                <ul className="d-none d-md-block text-end">
                    <li>
                       <a href="mailto:support@mokshiq.in"> Need Help <i className="iconoir-help-circle"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>
  )
}

export default Footer